import { useEffect } from 'react';
import { statusOf } from './create-busy';

/** Broadcast when the session is dead: the auth layer clears the tokens and sends the person to the login page. */
export const SESSION_ENDED_EVENT = 'app:auth-logout';

/** Ends the session through the same path a failed token refresh takes. */
export function endSession(target: Pick<EventTarget, 'dispatchEvent'> = window): void {
  target.dispatchEvent(new CustomEvent(SESSION_ENDED_EVENT));
}

/** A failed request that says the session is over (401): the screen shows nothing of its own, the person is taken to sign in. */
export function endsSession(error: unknown): boolean {
  return statusOf(error) === 401;
}

/** Ends the session when a query failed with 401, so no error card is drawn for it. */
export function useEndSessionOn401(error: unknown): void {
  const ended = endsSession(error);
  useEffect(() => {
    if (ended) endSession();
  }, [ended]);
}
